export const tabInfo = (tabName) => {
  const favicon = document.querySelector("link[rel='icon']");
  process.env.REACT_APP_SUB_DOMAIN && favicon?.parentNode?.removeChild(favicon);
  document.title = tabName;
};